<template>
  <div class="clients" v-resize="onResizePage">
    <div class="content">
      <div class="wrap">
        <div class="wrap__tree">
          <div class="nav-tree">
            <h3>Clients</h3>
            <el-dropdown @command="handleCommand">
              <el-button class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_action')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  v-if="companyLayout" command="addClient" :disabled="!companyLayout.permission.addVendors" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Add Clients</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="editClient" v-show="disabledBtn" :disabled="!companyLayout.permission.updateVendors || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Edit Clients</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="activeInactiveClient" v-show="disabledBtn" :disabled="true || !companyLayout.permission.updateVendors || true" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Active/Inactive</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="deleteClient" v-show="disabledBtn" :disabled="!companyLayout.permission.deleteVendors || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">Delete Clients</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="addContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.addVendorsPerson || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Add Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="editContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.updateVendorsPerson || selectedRow.type === 'client'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Edit Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="deleteContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.updateVendorsPerson || selectedRow.type === 'client'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Delete Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="addToBu" :disabled="selectedRow.type === 'person'" v-show="disabledBtn"  class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Add To BU</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="importClients" v-show="disabledBtn" :disabled="false"  class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Import Clients</el-dropdown-item>
<!--                <el-dropdown-item  v-if="companyLayout" command="addContact" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Contact</el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
            <ag-grid-vue style="width: 100%; height: 96%;" class="ag-theme-balham" id="myGrid"
              :gridOptions="gridOptions"
              @grid-ready="onGridReady"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :getRowHeight="getRowHeight"
              :getDataPath="getDataPath"
              :rowDragManaged="true"
              :animateRows="true"
              :rowData="rowData"
              :floatingFilter="true"
              :rowSelection="rowSelection"
              :suppressMultiSort="false"
              @selection-changed="onSelectionChanged"
              :suppressContextMenu="true"
              :getRowNodeId="getRowNodeId"
              :autoGroupColumnDef="autoGroupColumnDef"
              :groupDefaultExpanded="groupDefaultExpanded"
              :treeData="true"></ag-grid-vue>
        </div>

        <div class="wrap__info">
          <div class="wrap__info-tab">

            <div style="margin-bottom: 10px;">
              <el-dropdown placement="bottom-start">
                <el-button disabled style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_function')}}</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_projectBookmark')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button :disabled="true" style="margin-right: 12px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">Client Calander</el-button>
              <el-button :disabled="true" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">Client Reports</el-button>
            </div>

            <el-tabs v-model="activeName" disabled type="border-card" @tab-click="handleClick">
              <el-tab-pane :label="$t('vendors_tab_info')" name="info">
                <ul>

                  <el-tabs v-model="detailsVendors">
                    <el-tab-pane label="Details" name="first">

                      <el-tabs v-model="infoVendors" @tab-click="handleClickInfo">

                        <!-- General -->
                        <el-tab-pane :label="$t('vendors_tab_vendors_general')" name="first">
                          <el-card>
                            <div v-if="this.selectedRow.type === 'client'">
                              <el-row :gutter="20">
                                <el-col :span="16" :offset="0">
                                  <li><div :class="{isEmpty: !info.name}" class="wrap__info-tab_label">{{$t('modal_full_name')}}:</div><span v-html="info.name"></span></li>
                                  <li><div :class="{isEmpty: !info.shortName}" class="wrap__info-tab_label">{{$t('modal_short_name')}}:</div><span v-html="info.shortName"></span></li>
                                  <li><div :class="{isEmpty: !info.email}" class="wrap__info-tab_label">{{$t('modal_email')}}:</div> <span v-html="info.email"></span></li>
                                  <li><div :class="{isEmpty: !info.website}" class="wrap__info-tab_label">{{$t('modal_website')}}:</div> <span><a :href="info.website" target="_blank">{{info.website}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.phone}" class="wrap__info-tab_label">{{$t('modal_phone_main')}}:</div><span v-html="info.phone"></span></li>
                                  <li><div :class="{isEmpty: !info.fax}" class="wrap__info-tab_label">{{$t('modal_fax_main')}}:</div><span v-html="info.fax"></span></li>
                                  <li><div :class="{isEmpty: !info.facebook}" class="wrap__info-tab_label">{{$t('modal_facebook')}}:</div> <span><a :href="info.facebook" target="_blank">{{info.facebook}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.linkedIn}" class="wrap__info-tab_label">{{$t('modal_linkedIn')}}:</div> <span><a :href="info.linkedIn" target="_blank">{{info.linkedIn}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.assignSupplyChainMgr}" class="wrap__info-tab_label">Account Mgr.:</div><span v-html="info.assignSupplyChainMgr"></span></li>
                                  <li><div :class="{isEmpty: !info.shippingMethod}" class="wrap__info-tab_label">{{$t('modal_shipping_method')}}:</div><span v-html="info.shippingMethod"></span></li>
                                  <li><div :class="{isEmpty: !info.tagAs}" class="wrap__info-tab_label">Tag As:</div><span v-html="info.tagAs"></span></li>
                                </el-col>
                                <el-col :span="8" :offset="0">
                                  <h4 style="margin-top: 0px;">Client QR</h4>
                                  <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                  <h4>Client ID</h4>
                                  <el-input disabled style="width: 200px;" placeholder="" size="normal" clearable></el-input>
                                </el-col>
                              </el-row>
                            </div>
                            <div v-else>
                              <li><div :class="{isEmpty: !info.primaryContact}" class="wrap__info-tab_label">Primary Contact:</div><span v-html="info.primaryContact ? 'Yes' : 'No'"></span></li>
                              <li><div :class="{isEmpty: !info.firstname}" class="wrap__info-tab_label">{{$t('modal_first_name')}}:</div><span v-html="info.firstname"></span></li>
                              <li><div :class="{isEmpty: !info.lastname}" class="wrap__info-tab_label">{{$t('modal_last_name')}}:</div><span v-html="info.lastname"></span></li>
                              <li><div :class="{isEmpty: !info.email}" class="wrap__info-tab_label">{{$t('modal_email')}}:</div> <span v-html="info.email"></span></li>
                              <li><div :class="{isEmpty: !info.position}" class="wrap__info-tab_label">Position:</div> <span v-html="info.position"></span></li>
                              <li><div :class="{isEmpty: !info.department}" class="wrap__info-tab_label">Department:</div> <span v-html="info.department"></span></li>
                              <li><div :class="{isEmpty: !info.workPhone}" class="wrap__info-tab_label">{{$t('modal_work_phone')}}:</div><span v-html="info.workPhone"></span></li>
                              <li><div :class="{isEmpty: !info.mobilePhone}" class="wrap__info-tab_label">{{$t('modal_phone')}}:</div><span v-html="info.mobilePhone"></span></li>
                              <li><div :class="{isEmpty: !info.skype}" class="wrap__info-tab_label">{{$t('modal_skype')}}:</div><span v-html="info.skype"></span></li>
                              <li><div :class="{isEmpty: !info.linkedIn}" class="wrap__info-tab_label">{{$t('modal_linkedIn')}}:</div> <span><a :href="info.linkedIn" target="_blank">{{info.linkedIn}}</a></span></li>
                              <li><div :class="{isEmpty: !info.facebook}" class="wrap__info-tab_label">{{$t('modal_facebook')}}:</div> <span><a :href="info.facebook" target="_blank">{{info.facebook}}</a></span></li>
                            </div>
                          </el-card>
                        </el-tab-pane>

                        <!-- Addresses -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_vendors_addresses')" name="second">
                          <el-card v-if="this.info.addresses">

                            <el-row :gutter="10">
                              <el-col :span="8" :offset="0" style="min-height: 400px;">
                                <h4 style="margin-top: 0px;">Main Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.mainAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.mainAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.mainAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.mainAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine3"></span></li>
                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map1" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                              <el-col :span="8" :offset="0">
                                <h4 style="margin-top: 0px;">Billing Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.billingAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.billingAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.billingAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.billingAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine3"></span></li>

                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map2" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                              <el-col :span="8" :offset="0">
                                <h4 style="margin-top: 0px;">Shipping/Warehouse Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3"></span></li>

                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map3" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                            </el-row>

                          </el-card>
                        </el-tab-pane>
                        <el-tab-pane v-else :label="$t('vendors_tab_vendors_addresses')" name="second">
                          <el-row :gutter="10">
                            <el-col :span="12" :offset="0" style="min-height: 400px;">

                              <li><div :class="{isEmpty: !this.info.country}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.country ? this.info.country.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.state}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.state ? this.info.state.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.city}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.city ? this.info.city.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.postCode"></span></li>
                              <li><div :class="{isEmpty: !this.info.address}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.address"></span></li>
                              <li><div :class="{isEmpty: !this.info.address2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.address2"></span></li>
                              <li><div :class="{isEmpty: !this.info.address3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.address3"></span></li>

                              <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                            </el-col>
                            <el-col :span="12" :offset="0">

                            </el-col>
                          </el-row>
                        </el-tab-pane>

                        <!-- Finance -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_vendors_finance')" name="third">
                          <el-card v-if="this.info.finance">
                            <el-row :gutter="20">
                              <el-col :span="8">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_general')}}:</h4>
                              </el-col>
                              <el-col :span="16">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_bank_details')}}:</h4>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="8">
                                <li><div :class="{isEmpty: !this.info.finance.currency}" class="wrap__info-tab_label">{{$t('modal_currency')}}:</div><span v-html="this.info.finance.currency ? this.info.finance.currency.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.creditLimit}" class="wrap__info-tab_label">{{$t('modal_credit_limit')}}:</div><span>{{formatPrice(this.info.finance.creditLimit)}}</span></li>
                                <li><div :class="{isEmpty: !this.info.finance.outstanding}" class="wrap__info-tab_label">Outstanding:</div><span v-html="this.info.finance.outstanding"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.paymentTerms}" class="wrap__info-tab_label">{{$t('modal_payment_terms')}}:</div><span v-html="this.info.finance.paymentTerms ? this.info.finance.paymentTerms.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.paymentTypes}" class="wrap__info-tab_label">{{$t('modal_payment_types')}}:</div><span v-html="this.info.finance.paymentTypes ? this.info.finance.paymentTypes.name : null"></span></li>
                              </el-col>
                              <el-col :span="16">
                                <li><div :class="{isEmpty: !this.info.finance.bankName}" class="wrap__info-tab_label">{{$t('modal_bank_name')}}:</div><span v-html="this.info.finance.bankName"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.bankAddress}" class="wrap__info-tab_label">{{$t('modal_bank_address')}}:</div><span v-if="this.info.addresses.bankAddress">{{this.info.addresses.bankAddress.country.name}} {{`, ${this.info.addresses.bankAddress.state.name}`}} {{`, ${this.info.addresses.bankAddress.city.name}`}} {{`, ${this.info.addresses.bankAddress.postCode}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine1}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine2}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine3}`}}</span></li>
                                <li><div :class="{isEmpty: !this.info.finance.SWIFTCode}" class="wrap__info-tab_label">{{$t('modal_SWIFT_code')}}:</div><span v-html="this.info.finance.SWIFTCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.accountName}" class="wrap__info-tab_label">{{$t('modal_account_name')}}:</div><span v-html="this.info.finance.accountName"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.branchSortCode}" class="wrap__info-tab_label">{{$t('modal_account_branch')}}:</div><span v-html="this.info.finance.branchSortCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.accountIBANNo}" class="wrap__info-tab_label">{{$t('modal_account_account')}}:</div><span v-html="this.info.finance.accountIBANNo"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                        <!-- Assessment -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" label="Assessment" name="fourth">
                          <el-card v-if="this.info.assessment">
                            <el-row :gutter="20">
                              <el-col :span="12">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_general')}}</h4>
                              </el-col>
                              <el-col :span="12">
                                <h4 style="margin-top: 0px;">Accounting</h4>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="12">
                                <li><div :class="{isEmpty: !this.info.assessment.startDate}" class="wrap__info-tab_label">Start Date:</div><span>{{this.info.assessment.startDate ? moment(this.info.assessment.startDate * 1000).format('D MMM YY') : null}}</span></li>
                                <li><div :class="{isEmpty: !this.info.assessment.code}" class="wrap__info-tab_label">Client Code:</div><span v-html="this.info.assessment.code"></span></li>
                                <li><div :class="{isEmpty: !this.info.assessment.ISOAccreditationNo}" class="wrap__info-tab_label">ISO Accreditation No.:</div><span v-html="this.info.assessment.ISOAccreditationNo"></span></li>
                                <li><div :class="{isEmpty: !this.info.assessment.sheetId}" class="wrap__info-tab_label">Assessment Sheet:</div><span v-html="this.info.assessment.sheetId"></span></li>
                                <li><div :class="{isEmpty: !this.info.assessment.category}" class="wrap__info-tab_label">Category:</div><span v-html="this.info.assessment.category"></span></li>
                              </el-col>
                              <el-col :span="12">
                                <li><div :class="{isEmpty: !this.info.assessment.serviceAccountId}" class="wrap__info-tab_label">Selling of Servise:</div><span v-html="this.info.assessment.serviceAccount ? this.info.assessment.serviceAccount.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.assessment.productAccountId}" class="wrap__info-tab_label">Selling of Products:</div><span v-html="this.info.assessment.productAccount ? this.info.assessment.productAccount.name : null"></span></li>
                              </el-col>
                            </el-row>

                          </el-card>
                        </el-tab-pane>

                        <!-- Account Team -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" label="Account Team" name="accountTeam">
                          <el-card>
                            <el-row :gutter="20">
                              <el-col :span="18" :offset="0">
                                <h4 style="margin-top: 0px;">Team</h4>
                              </el-col>
                              <el-col :span="6" :offset="0" style="text-align: right;">
                                <el-button type="primary" size="mini" @click="addTeam">Add Team</el-button>
                              </el-col>
                            </el-row>

                            <div v-for="item in accountTeamList" :key="item.id">
                              <li><div class="wrap__info-tab_label">Business Unit:</div><span>{{item.businessUnit.name}}</span></li>
                              <li><div class="wrap__info-tab_label">First Name:</div><span>{{item.user.firstname}}</span></li>
                              <li><div class="wrap__info-tab_label">Last Name:</div><span>{{item.user.lastname}}</span></li>
                              <li><div class="wrap__info-tab_label">Email:</div><span>{{item.user.email}}</span></li>
                              <li><div class="wrap__info-tab_label">Date Assigned:</div><span>{{moment(item.assignedDate * 1000).format('D MMM YY')}}</span></li>
                              <hr>
                            </div>
                          </el-card>
                        </el-tab-pane>

                        <!-- Custom -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_vendors_custom')" name="fifth">
                          <el-card v-if="this.info.custom">
                            <li><div :class="{isEmpty: !this.info.custom.customField1}" class="wrap__info-tab_label">{{$t('modal_custom_field_1')}}:</div><span v-html="this.info.custom.customField1"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField2}" class="wrap__info-tab_label">{{$t('modal_custom_field_2')}}:</div><span v-html="this.info.custom.customField2"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField3}" class="wrap__info-tab_label">{{$t('modal_custom_field_3')}}:</div><span v-html="this.info.custom.customField3"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField4}" class="wrap__info-tab_label">{{$t('modal_custom_field_4')}}:</div><span v-html="this.info.custom.customField4"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField5}" class="wrap__info-tab_label">{{$t('modal_custom_field_5')}}:</div><span v-html="this.info.custom.customField5"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField6}" class="wrap__info-tab_label">{{$t('modal_custom_field_6')}}:</div><span v-html="this.info.custom.customField6"></span></li>
                          </el-card>
                        </el-tab-pane>

                        <!-- Tax Settings -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client'" label="Tax Settings" name="settings">
                          <el-card v-if="this.info.tax">
                            <el-row :gutter="20">
                              <el-col :span="11">
                                <li><div :class="{isEmpty: !this.info.tax.serviceOrProduct}" class="wrap__info-tab_label">{{$t('modal_product_or_service')}}:</div><span v-html="this.info.tax.serviceOrProduct ? this.info.tax.serviceOrProduct.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.saleTax}" class="wrap__info-tab_label">{{$t('modal_tax_type_vat')}}:</div><span v-html="this.info.tax.saleTax ? this.info.tax.saleTax.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.saleTax}" class="wrap__info-tab_label">Tax Code (VAT):</div><span v-html="this.info.tax.saleTax ? this.info.tax.saleTax.tax.code : null"></span></li>
                                <li><div class="wrap__info-tab_label">Apply Withholding Tax:</div><span v-html="(this.info.tax.productWithholdingTax || this.info.tax.serviceWithholdingTax) ? 'Yes' : 'No'"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.productWithholdingTax}" class="wrap__info-tab_label">Tax Type (WHT) Product:</div><span v-html="this.info.tax.productWithholdingTax ? this.info.tax.productWithholdingTax.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.productWithholdingTax}" class="wrap__info-tab_label">Tax Code (WHT) Product:</div><span v-html="this.info.tax.productWithholdingTax ? this.info.tax.productWithholdingTax.tax.code : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.serviceWithholdingTax}" class="wrap__info-tab_label">Tax Type (WHT) Service:</div><span v-html="this.info.tax.serviceWithholdingTax ? this.info.tax.serviceWithholdingTax.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.serviceWithholdingTax}" class="wrap__info-tab_label">Tax Code (WHT) Service:</div><span v-html="this.info.tax.serviceWithholdingTax ? this.info.tax.serviceWithholdingTax.tax.code : null"></span></li>
                              </el-col>
                              <el-col :span="13">
                                <li><div class="wrap__info-tab_label">Creditable Withholding VAT:</div><span v-html="this.info.tax.clientWithholding ? 'Yes' : 'No'"></span></li>
                                <li v-if="this.info.tax.clientWithholding"><div class="wrap__info-tab_label">Tax Type (VAT):</div><span v-text="this.info.tax.clientWithholdingTax.name"></span></li>
                                <li v-if="this.info.tax.clientWithholding"><div class="wrap__info-tab_label">Tax Code (VAT):</div><span v-text="this.info.tax.clientWithholdingTax.tax.code"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                        <!-- Expanded -->
                        <el-tab-pane v-if="this.selectedRow.type === 'client' && this.info.enableExpanded" :label="$t('vendors_tab_vendors_expanded')" name="sixth">
                          <el-card v-if="this.info.expanded">
                            <el-row :gutter="20">
                              <el-col :span="11">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_general')}}</h4>
                              </el-col>
                              <el-col :span="13">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_tax_compliance')}}</h4>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="11">
                                <li><div :class="{isEmpty: !this.info.expanded.general.country}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.expanded.general.country ? this.info.expanded.general.country.name : null"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div class="wrap__info-tab_label">Registration Body:</div><span>Department of Trade & Industry</span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 2"><div class="wrap__info-tab_label">Registration Body:</div><span>Security & Exchange Commission</span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 3"><div class="wrap__info-tab_label">Registration Body:</div><span>Cooperative Development Authority</span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.industryTypeId}" class="wrap__info-tab_label">Industry Type:</div><span v-html="this.info.expanded.general.industryType ? this.info.expanded.general.industryType.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.categoryOfClientId}" class="wrap__info-tab_label">Category Of Client:</div><span v-html="this.info.expanded.general.categoryOfClient ? this.info.expanded.general.categoryOfClient.name : null"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId !== 1"><div :class="{isEmpty: !this.info.expanded.general.companyName}" class="wrap__info-tab_label">Registered Name:</div><span v-html="this.info.expanded.general.companyName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.firstName}" class="wrap__info-tab_label">First Name:</div><span v-html="this.info.expanded.general.firstName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.middleName}" class="wrap__info-tab_label">Middle Name:</div><span v-html="this.info.expanded.general.middleName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.surname}" class="wrap__info-tab_label">Surname:</div><span v-html="this.info.expanded.general.surname"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.tradeName}" class="wrap__info-tab_label">Trade Name:</div><span v-html="this.info.expanded.general.tradeName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.osca}" class="wrap__info-tab_label">Office for Senior Citizens Affairs (OSCA):</div><span v-html="this.info.expanded.general.osca"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.pwd}" class="wrap__info-tab_label">Person with Disabilities (PWD):</div><span v-html="this.info.expanded.general.pwd"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.registrationSECNo}" class="wrap__info-tab_label">{{$t('modal_sec')}}:</div><span v-html="this.info.expanded.general.registrationSECNo"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.rdo}" class="wrap__info-tab_label">RDO Office:</div><span v-html="this.info.expanded.general.rdo ? this.info.expanded.general.rdo.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.barangay}" class="wrap__info-tab_label">Barangay:</div><span v-html="this.info.expanded.general.barangay"></span></li>
                              </el-col>
                              <el-col :span="13">
                                <li><div :class="{isEmpty: !this.info.expanded.compliance.taxClassification}" class="wrap__info-tab_label">{{$t('modal_tax_classification')}}:</div><span v-html="this.info.expanded.compliance.taxClassification ? this.info.expanded.compliance.taxClassification.name : null"></span></li>
                                <li v-if="!this.info.expanded.compliance.occupationId"><div :class="{isEmpty: !this.info.expanded.compliance.lineOfBusiness}" class="wrap__info-tab_label">Line of Business (PSIC):</div><span v-html="this.info.expanded.compliance.lineOfBusiness ? this.info.expanded.compliance.lineOfBusiness.name : null"></span></li>
                                <li v-else><div :class="{isEmpty: !this.info.expanded.compliance.occupation}" class="wrap__info-tab_label">Occupation (PSOC):</div><span v-html="this.info.expanded.compliance.occupation ? this.info.expanded.compliance.occupation.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.compliance.taxIdentificationNo}" class="wrap__info-tab_label">{{$t('modal_tin')}}:</div><span v-html="this.info.expanded.compliance.taxIdentificationNo"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                      </el-tabs>

                    </el-tab-pane>
                    <el-tab-pane disabled label="About" name="about"></el-tab-pane>
                    <el-tab-pane disabled label="History" name="history"></el-tab-pane>
                    <el-tab-pane disabled label="Items" name="items"></el-tab-pane>
                    <!-- BU -->
                    <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_bu')" name="businessUnit">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_bu_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="businessUnitList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="BU No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBU(businessUnitList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Name">
                                  <template slot-scope="scope">
                                    {{businessUnitList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_bu')" name="businessUnit">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_bu_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="businessUnitList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="BU No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBU(businessUnitList[scope.$index].businessUnit.id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].businessUnit.code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Name">
                                  <template slot-scope="scope">
                                    {{businessUnitList[scope.$index].businessUnit.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBUTask(businessUnitList[scope.$index].businessUnit.id, businessUnitList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <!-- <el-tab-pane disabled label="Warehouses" name="warehouses"></el-tab-pane> -->
                    <!-- E -->
                    <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_e')" name="engagement">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_e_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="engagementList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="ENG No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkE(engagementList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Name">
                                  <template slot-scope="scope">
                                    {{engagementList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_e')" name="engagement">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_e_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="engagementList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="ENG No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkE(engagementList[scope.$index].engagement.id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].engagement.code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Name">
                                  <template slot-scope="scope">
                                    {{engagementList[scope.$index].engagement.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkETask(engagementList[scope.$index].engagement.id, engagementList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <!-- P -->
                    <el-tab-pane v-if="this.selectedRow.type === 'client'" :label="$t('vendors_tab_project')" name="projects">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_project_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="projectList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="PRO No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="link(projectList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].no}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="PRO Name">
                                  <template slot-scope="scope">
                                    {{projectList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_project')" name="projects">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_project_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="projectList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="PRO No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="link(projectList[scope.$index].project.id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].project.no}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="PRO Name">
                                  <template slot-scope="scope">
                                    {{projectList[scope.$index].project.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="PRO Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkTask(projectList[scope.$index].project.id, projectList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                  </el-tabs>

                </ul>
              </el-tab-pane>
              <!-- <el-tab-pane v-if="selectedRow.type === 'client'" :label="$t('vendors_tab_files')" name="clientFiles">
                <vendors-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane  v-else :label="$t('vendors_tab_files')" name="clientPersonFiles">
                <vendors-persons-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane> -->
              <el-tab-pane v-if="selectedRow.type === 'client'" :label="$t('vendors_tab_files')" name="clientFiles">
                <clients-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane  v-else :label="$t('vendors_tab_files')" name="clientPersonFiles">
                <clients-persons-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane>
              <!-- <el-tab-pane disabled label="Files" name="files"></el-tab-pane> -->
              <el-tab-pane v-if="selectedRow.type === 'client'" :label="$t('project_tab_comments')" name="clientComment">
                <client-comment ref="clientComment" :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane v-else disabled :label="$t('project_tab_comments')" name="clientPersonsComment"></el-tab-pane>
              <el-tab-pane disabled label="Messages" name="messages"></el-tab-pane>
              <el-tab-pane v-if="selectedRow.type === 'client'" label="Meetings" name="clientMeetings">
                <client-meetings ref="clientMeetings"/>
              </el-tab-pane>
              <el-tab-pane v-else label="Meetings" name="clientPersonsMeetings">
                <client-persons-meetings ref="clientPersonsMeetings"/>
              </el-tab-pane>
              <!-- <el-tab-pane :label="$t('vendors_tab_mgt')" name="supplyChainTab">
                <SupplyChainTab/>
              </el-tab-pane>
              <el-tab-pane :label="$t('vendors_tab_accountTHINK')" name="accountTHINK">
                <AccountThinkTab/>
              </el-tab-pane> -->
              <el-tab-pane disabled label="CRM" name="scm">
                <!-- TODO -->
              </el-tab-pane>
              <el-tab-pane v-if="selectedRow.type === 'client'" label="TF Accounting" name="at">
                <clientAT ref="clientAT" :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane disabled label="Compliance" name="compliance">
                <!-- TODO -->
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <sweet-modal blocking :title="$t('modal_vendor_address')" ref="address" class="modal">
          <iframe width="100%" height="400px" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        </sweet-modal>

        <sweet-modal blocking width="500" title="Assign Business Unit" ref="modalAddToBu" class="modal" v-on:close="closeModalBU">
          <el-select v-model="businessUnitsIdArr" placeholder="Business Unit" multiple style="width: 100%; margin-bottom: 20px;">
            <el-option v-for="item in businessUnitsList"
              :disabled="item.exist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>

          <div class="modal__btn">
            <el-button @click="modalCancel('modalAddToBu')">{{$t('general_cancel')}}</el-button>
            <el-button :disabled="businessUnitsIdArr.length === 0" @click="submitFormBU()" type="primary">{{$t('general_submit')}}</el-button>
          </div>
        </sweet-modal>

        <sweet-modal blocking width="500" title="Add Team" ref="addTeam" class="modal" v-on:close="closeModal">
          <el-form :model="model" status-icon :rules="rules" ref="model">

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="businessUnitId">
                  <el-select v-model="model.businessUnitId" placeholder="Select Business Unit" filterable size="mini" style="width: 100%;">
                    <el-option v-for="item in accountTeamBUList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @click.native="selectBU(item)">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="userId">
                  <el-select v-model="model.userId" placeholder="Select User" filterable size="mini" style="width: 100%;">
                    <el-option v-for="item in accountTeamUsersList"
                      :key="item.id"
                      :label="item.fullName"
                      :value="item.id">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="assignedDate">
                  <el-date-picker
                    style="width: 100%;"
                    v-model="model.assignedDate"
                    format="d MMM yy"
                    value-format="timestamp"
                    type="date"
                    placeholder="Date Assigned">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="modal__btn">
              <el-button @click="modalCancel('addTeam')">{{$t('general_cancel')}}</el-button>
              <el-button @click="submitForm('model')" type="primary">{{$t('general_submit')}}</el-button>
            </el-form-item>
          </el-form>
        </sweet-modal>

      </div>
    </div>

    <sweet-modal blocking title="Import Clients" width="700" ref="importClients" class="modal">
      <!-- <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">countryId</div>
          <el-select no-data-text="no data" v-model="mainCountryId" @visible-change="loadMainCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainCountryList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setState('main', item)">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">stateId</div>
          <el-select no-data-text="no data" v-model="mainStateId" @visible-change="loadMainStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainStateList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setCity('main', item)">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">cityId</div>
          <el-select no-data-text="no data" v-model="mainCityId" @visible-change="loadMainCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainCityList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row v-if="directoriesForImport" :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">companyTypeId</div>
          <el-select v-model="companyTypeId" size="mini" :placeholder="$t('modal_product_or_service')" clearable filterable style="width: 100%;">
            <el-option v-for="item in directoriesForImport.serviceTypesList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">currencyId</div>
          <el-select v-model="currencyId" size="mini" :placeholder="$t('modal_currency')" style="width: 100%;" filterable>
            <el-option v-for="item in directoriesForImport.currenciesList"
              :key="item.id"
              :label="`${item.code} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">saleTaxId</div>
          <el-select v-model="saleTaxId" size="mini" :placeholder="$t('modal_tax_type_vat')" clearable filterable style="width: 100%;">
            <el-option v-for="item in directoriesForImport.outputTaxSubAccounts"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setTaxCode('taxCode', item)">
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->

      <p>Download the tamplate file and follow instruction from first Sheet</p>

      <div style="margin-bottom: 20px;">
        <a :href="downloadURL" download>Download template XLS</a>
      </div>

      <form class="importClients">
        <label for="fileImport" class="importClients__label">
          <i class="el-icon-upload"></i> {{$t('modal_uploadFile')}}
        </label>
        <input v-show="false" @change="handleFileImport" ref="fileImport" id="fileImport" name="myFileImport" type="file">
      </form>
    </sweet-modal>

    <AddClientForm ref="modal11" :directories="directories" @selected="selected"/>
    <EditClientForm ref="modal22" :directories="directories" :companyClientsItem="companyClientsItem" @selected="selected"/>

    <AddPerson ref="modal3" :directories="personsDirectories" @selected="selected"/>
    <EditPerson ref="modal4" :directories="personsDirectories" :companyClientsPersonsItem="companyClientsPersonsItem" @selected="selected"/>
  </div>
</template>

<script>
import moment from 'moment'
import AddClientForm from '@/components/clients/AddClientForm.vue'
import EditClientForm from '@/components/clients/EditClientForm.vue'
import SupplyChainTab from '@/components/vendors/SupplyChainTab.vue'
import AccountThinkTab from '@/components/vendors/AccountThinkTab.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import {AgGridVue} from "ag-grid-vue"
import axios from 'axios'
import resize from 'vue-resize-directive'
import AddPerson from "../components/clients/AddPerson";
import EditPerson from '@/components/clients/EditPerson.vue'
import VendorsFilesTab from "../components/vendors/VendorsFilesTab";
import VendorsPersonsFilesTab from "../components/vendors/VendorsPersonsFilesTab";
import ClientComment from "@/components/clients/ClientComment.vue"
import clientAT from "@/components/clients/ClientAT.vue"
import ClientMeetings from "@/components/clients/ClientMeetings.vue"
import ClientPersonsMeetings from "@/components/clients/ClientPersonsMeetings.vue"
import ClientsFilesTab from "../components/clients/ClientsFilesTab";
import ClientsPersonsFilesTab from "../components/clients/ClientsPersonsFilesTab";
export default {
  name: 'clients',
  directives: {
    resize
  },
  components: {
    VendorsPersonsFilesTab,
    VendorsFilesTab,
    AddPerson,
    EditPerson,
    AddClientForm,
    EditClientForm,
    AgGridVue,
    SweetModal,
    SupplyChainTab,
    AccountThinkTab,
    ClientComment,
    clientAT,
    ClientMeetings,
    ClientPersonsMeetings,
    ClientsFilesTab,
    ClientsPersonsFilesTab,
  },
  created() {
    this.$store.dispatch('getRowDataClients')
  },
  computed: {
    rowData() {
      return this.$store.getters.getRowDataClients
    },
    companyLayout() {
      return this.$store.state.companyLayout
    }
  },
  data() {
    return {
      directoriesForImport: null,
      downloadURL: null,

      mainCountryId: null,
      mainCountryList: [],
      mainStateId: null,
      mainStateList: [],
      mainCityId: null,
      mainCityList: [],

      companyTypeId: null,
      currencyId: null,
      saleTaxId: null,

      businessUnitsList: [],
      businessUnitsIdArr: [],
      map: '',
      map1: '',
      map2: '',
      map3: '',
      moment:moment,
      activeName: 'info',
      detailsVendors: 'first',
      infoVendors: 'first',
      disabledBtn: false,
      selectedRow: {},

      directories: null,
      companyClientsItem: null,

      info: {
        enableExpanded: false,
        // General
        id: '',
        name: '',
        shortName: null,
        email: '',
        website: '',
        phone: '',
        linkedIn: '',
        facebook: '',
        fax: '',
        assignSupplyChainMgr: '',
        shippingMethod: '',
        tagAs: '',

        firstname: null,
        lastname: null,
        skype: null,
        workPhone: null,
        mobilePhone: null,

        addresses: null,
        // Address
        isAddressAssigned: false,

        country: null,
        state: null,
        city: null,
        address: '',
        address2: '',
        address3: '',
        postCode: '',

        finance: null,
        // Finance
        currencyId: null,
        creditLimit: null,
        paymentTerms: null,
        paymentTypes: null,
        bankName: null,
        bankAddress: null,
        SWIFTCode: null,
        accountName: null,
        branchSortCode: null,
        accountIBANNo: null,

        assessment: null,
        // Assessment
        startDate: null,
        code: null,
        ISOAccreditationNo: null,
        sheetId: null,
        category: null,
        defaultAccounts: null,

        custom: null,
        // Custom
        customField1: null,
        customField2: null,
        customField3: null,
        customField4: null,
        customField5: null,
        customField6: null,

        tax: null,

        expanded: null,
        // Expanded
        // --General
        expandedCountry: null,
        companyName: null,
        registrationSECNo: null,
        lineOfBusiness: null,
        RDOBarangay: null,
        region: null,
        // --General
        taxClassification: null,
        taxIdentificationNo: null,
        productOrService: null,
        taxType: null,
        taxCode: null,
        applyWithholdingTax: null,
      },

      businessUnitList: [],
      engagementList: [],
      projectList: [],

      // Tree
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      getRowHeight:null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,
      personsDirectories: null,
      getDataPath: null,
      getRowNodeId: null,
      autoGroupColumnDef: null,
      groupDefaultExpanded: null,
      companyClientsPersonsItem: null,

      accountTeamList: [],
      accountTeamBUList: [],
      accountTeamUsersList: [],
      model: {
        businessUnitId: null,
        userId: null,
        assignedDate: null,
      },

      rules: {
        businessUnitId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        userId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        assignedDate: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
      }
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
    };
    this.columnDefs = [
      {
        // headerName: this.$i18n.t('vendors_id'),
        headerName: '#',
        field: "id",
        filter: false,
        headerClass: 'id-column',
        width: 12,
        cellRenderer: function(params) {
          return `<span class="txtRender">${ params.node.data.type === 'vendor' ? params.node.data.id : '' }</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'left; display: flex; justify-content:flex-start; padding-left: 10px;'}
        }
      },
      // { field: this.$i18n.t('vendors_name'),
      //   filter: "agTextColumnFilter",
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.name}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_email'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.email}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_phone'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //   if(params.node.data.phone){
      //     return `<span class="txtRender">${params.node.data.phone}</span>`
      //   }
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_dateCreated'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.dateCreated}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // }
    ];
    this.getRowHeight = params => {
      return 40;
    };
    this.defaultColDef = {
      suppressMovable: true,
      suppressMenu: true,
      resizable: true,
      width: 150,
      filter: true,
      floatingFilter: true,
      sortable: true
    };
    this.rowSelection = "single"
    this.groupDefaultExpanded = -1;
    this.getDataPath = data => {
      return data.filePath
    }
    this.getRowNodeId = data => {
      return data.id
    }
    this.autoGroupColumnDef = {
      filter: 'agTextColumnFilter',
      headerName: 'Name (Client / Client Contact)',
      field: 'name',
      cellRendererParams: {
        suppressCount: true,
        // innerRenderer: "fileCellRenderer"
        // innerRenderer: "txtRenderer"
        innerRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.name || params.node.data.fullName}</span>`
        }
      },
      cellStyle: function(params) {
        return {'text-align': 'center; display: flex;'}
      },
      cellClass: 'name-cell'
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.hidePopupMenu();
    this.gridColumnApi.moveColumn("id", 0);
  },
  methods: {
    async getDirectories() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=client&countryId=${this.companyLayout.countryId}`)
        .then(response => {
          console.log('client-vendor/directories', response.data);
          this.directoriesForImport = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    async getURL() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories-for-import?companyId=${this.$route.query.companyId}&type=client`)
        .then(response => {
          this.downloadURL = response.data.downloadPath
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Main Address
    loadMainCountryList(isVisiable) {
      if (isVisiable && this.mainCountryList.length < 2) {
        this.loadList('country', null, 'mainCountryList')
      }
    },
    loadMainStateList(isVisiable) {
      if (isVisiable && this.mainStateList.length < 2) {
        this.loadList('state', this.mainCountryId, 'mainStateList')
      }
    },
    loadMainCityList(isVisiable) {
      if (isVisiable && this.mainCityList.length < 2) {
        this.loadList('city', this.mainStateId, 'mainCityList')
      }
    },
    setState(type, item) {
      if (type === 'main') {
        this.mainStateId = null;
        this.mainCityId = null;
        this.mainStateList = []
        this.mainCityList = []
      }
    },
    setCity(type, item) {
      if (type === 'main') {
        this.mainCityId = null
        this.mainCityList = []
      }
    },
    handleFileImport(e) {
      // TODO:
      var formData = new FormData();
      formData.append('file', e.target.files[0]);

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/client-vendor/import?companyId=${this.$route.query.companyId}&entityType=client`, formData)
        .then(response => {
          this.notification("Success", "File upload", "success")
          this.$refs.fileImport.value = ''
          this.$store.dispatch('getRowDataClients')
          this.$refs.importClients.close()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          this.$refs.fileImport.value = ''
          loader.hide()
        });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    loadAccountTeamList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/account-team?id=${this.selectedRow.vendorId}`)
        .then(response => {
          this.accountTeamList = response.data.item
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    addTeam() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/businessUnits/user/list?companyId=${this.$route.query.companyId}`)
        .then(response => {
          console.log('/api/v1/businessUnits/user/list', response.data);
          this.accountTeamBUList = response.data.list
          this.$refs['addTeam'].open()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    selectBU(item) {
      this.model.userId = null
      this.accountTeamUsersList = item.userList
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/client/add-pm?companyId=${this.$route.query.companyId}&companyClientId=${this.selectedRow.vendorId}&businessUnitId=${this.model.businessUnitId}&userId=${this.model.userId}&assignedDate=${this.model.assignedDate / 1000}`)
            .then(response => {
              this.loadAccountTeamList()
              this.$refs.addTeam.close();
              this.notification("Success", "Add Team", "success");
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['model'].resetFields();
    },
    openMap() {
      let address = this.info.country + ',' +  this.info.state + ',' +  this.info.city
      if (this.info.address) {
        address = address + ',' + this.info.address
      }
      if (this.info.address2 > 0) {
        address = address + ',' + this.info.address2
      }
      if (this.info.address3.length > 0) {
        address = address + ',' + this.info.address3
      }
      this.map = 'https://maps.google.com/maps?q=' + address + '&t=&z=13&ie=UTF8&iwloc=&output=embed'
      this.$refs['address'].open()
    },
    link(id) {
      localStorage.setItem('selectedProjectId', id)
      this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${id}`);
    },
    linkTask(id, taskId) {
      localStorage.setItem('selectedProjectId', id)
      this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${id}&taskId=${taskId}`);
    },
    linkBU(id) {
      localStorage.setItem('selectedBusinessUnitId', id)
      this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${id}`);
    },
    linkBUTask(id, taskId) {
      localStorage.setItem('selectedBusinessUnitId', id)
      this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${id}&taskId=${taskId}`);
    },
    linkE(id) {
      localStorage.setItem('selectedEngagementId', id)
      this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${id}`);
    },
    linkETask(id, taskId) {
      localStorage.setItem('selectedEngagementId', id)
      this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${id}&taskId=${taskId}`);
    },
    onResizePage(val){
      this.gridApi.sizeColumnsToFit()
    },
    async handleCommand(command){
      console.log('this', this.rowData)
      console.log('command', command)
      switch (command) {
        case 'addClient':
          this.addClient()
          break;
        case 'editClient':
          this.editClient()
          break;
        case 'deleteClient':
          this.deleteClient()
          break;
        case 'addContact':
          this.addPerson()
          break;
        case 'editContact':
          this.editPerson()
          break;
        case 'deleteContact':
          this.deletePerson()
          break;
        case 'addToBu':
          this.openModalAddToBu()
          break;
        case 'importClients':
          await this.getDirectories()
          await this.getURL()
          this.$refs.importClients.open()
          break;
        default:
      }
    },
    async openModalAddToBu() {
      const { data } = await axios.get(`/api/v1/businessUnits/cv/list?entityType=client&entityId=${this.selectedRow.vendorId}&companyId=${this.$route.query.companyId}`)
      this.businessUnitsList = data.list
      this.$refs.modalAddToBu.open()
    },
    submitFormBU() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/client-vendor/add-to-bu?entityType=client`, {
          id: this.selectedRow.vendorId,
          buId: this.businessUnitsIdArr
        })
        .then(response => {
          this.$store.dispatch('getRowDataClients')
          this.$refs.modalAddToBu.close()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    closeModalBU() {
      this.businessUnitsList = []
      this.businessUnitsIdArr = []
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    openDialog(){
      this.$emit('openChat2')
    },
    addClient() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=client&countryId=${this.companyLayout.countryId}`)
        .then(response => {
          console.log('client-vendor/directories', response.data);
          this.directories = response.data.list
          this.$refs['modal11'].openModal()

          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    editClient() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor?companyId=null&entityType=client&id=${this.selectedRow.vendorId}`)
        .then(response => {
          console.log('---/companyVendors/item', response.data);
          this.companyClientsItem = response.data.result[0]

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=client&countryId=${this.companyLayout.countryId}`)
            .then(response => {
              console.log('---/companyVendors/directories', response.data);
              this.directories = response.data.list
              this.$refs['modal22'].openModal()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
            // loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    deleteClient() {
      this.$confirm('This will permanently delete the client. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        console.log('---', 'deleteClient');
        let selectedRows = this.gridApi.getSelectedRows();
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/client-vendor/delete?entityType=client&id=${this.selectedRow.vendorId}`)
            .then(response => {
                this.$store.dispatch('getRowDataClients')
                this.$store.dispatch('getMenuStatistics')
                this.notification("Success", "Delete Client", "success")
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    deletePerson() {
      this.$confirm('This will permanently delete the contact. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyClientPersons/delete?companyId=${this.$route.query.companyId}&companyClientId=${this.$route.query.companyClientId}&companyClientPersonId=${this.$route.query.companyClientPersonId}`)
            .then(response => {
              this.$store.dispatch('getRowDataClients')
              this.$store.dispatch('getMenuStatistics')
              this.notification("Success", "Delete Persons", "success")
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    selected(id) {
      var selectedId = id
      if (selectedId) {
        setTimeout(() => {
          this.selectCreatedTask(selectedId)
        }, 2000);
      } else {
        setTimeout(() => {
          this.selectCreatedTask(this.selectedRow.vendorId)
        }, 2000);
      }
    },
    selectCreatedTask(id){
      this.gridApi.forEachNode(function (node) {
        console.log("NODE DATA", node.data.vendorId)
        console.log("NODE DATA ID COMPARE", id)
        if (node.data.vendorId === id) {
          node.setSelected(true);
          console.log("NODE SELECTED")
        }
      });
    },
    onBtSuppressRowDrag() {
      this.gridApi.setSuppressRowDrag(true);
    },
    onBtShowRowDrag() {
      this.gridApi.setSuppressRowDrag(false);
    },
    onGridReady(params) {
      setTimeout(() => {
        if (this.rowData.length) {
          this.selectRow(0)
        }
      }, 1500)
    },
    selectRow(indexArg) {
      return new Promise ((resolve, reject) => {
        this.gridApi.forEachNode((node, index) => {
          if (index === indexArg) {
            this.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
            node.setSelected(true)
            resolve(node)
          }
        })
      })
    },
    onSelectionChanged() {
      this.activeName = 'info'
      this.detailsVendors = 'first'
      this.infoVendors = 'first'
      // check if really row selected or deselectAll()
      if (!this.gridApi.getSelectedRows().length) return;

      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedRow = selectedRows[0];

      if (this.selectedRow.type === 'client') {
        switch (this.activeName) {
          case 'clientPersonFiles':
            this.activeName = 'clientFiles'
            break;
        }
      }

      if (this.selectedRow.type === 'person') {
        switch (this.activeName) {
          case 'clientFiles':
            this.activeName = 'clientPersonFiles'
            break;
        }
      }

      this.disabledBtn = true;
      console.log('---ROW', selectedRows);

      // General
      // client
      this.info.id = selectedRows[0].vendorId;
      this.info.name = selectedRows[0].name;
      this.info.shortName = selectedRows[0].shortName;
      this.info.email = selectedRows[0].email;
      this.info.website = selectedRows[0].website;
      this.info.linkedIn = selectedRows[0].linkedIn;
      this.info.facebook = selectedRows[0].facebook;
      this.info.phone = selectedRows[0].phone;
      this.info.fax = selectedRows[0].fax;
      this.info.assignSupplyChainMgr = selectedRows[0].assignSupplyChainMgr;
      this.info.shippingMethod = selectedRows[0].shippingMethod;
      this.info.tagAs = selectedRows[0].tagAs;

      // person
      this.info.firstname = selectedRows[0].firstname
      this.info.primaryContact = selectedRows[0].primaryContact
      this.info.position = selectedRows[0].position
      this.info.department = selectedRows[0].department,
      this.info.lastname = selectedRows[0].lastname
      this.info.skype = selectedRows[0].skype
      this.info.workPhone = selectedRows[0].workPhone
      this.info.mobilePhone = selectedRows[0].mobilePhone

      this.info.country = selectedRows[0].country
      this.info.state = selectedRows[0].state
      this.info.city = selectedRows[0].city
      this.info.postCode = selectedRows[0].postCode
      this.info.address = selectedRows[0].addressLine1
      this.info.address2 = selectedRows[0].addressLine2
      this.info.address3 = selectedRows[0].addressLine3

      if (this.selectedRow.type === 'client') {
        this.$router.push(`/clients?companyId=${this.$route.query.companyId}&companyClientId=${selectedRows[0].vendorId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/client-vendor?companyId=null&entityType=client&id=${selectedRows[0].vendorId}`)
          .then(response => {
            // Address
            this.info.addresses = response.data.result[0].addresses

            // Finance
            this.info.finance = response.data.result[0].finance

            // Assessment
            this.info.assessment = response.data.result[0].assessment,

            // Custom
            this.info.custom = response.data.result[0].custom

            this.info.enableExpanded = response.data.result[0].enableExpanded

            // Tax Settings
            this.info.tax = response.data.result[0].tax

            // Expanded
            this.info.expanded = response.data.result[0].expanded

            this.businessUnitList = response.data.result[0].entityData.businessUnitList
            this.engagementList = response.data.result[0].entityData.engagementList
            this.projectList = response.data.result[0].entityData.projectList

            this.map1 = `https://maps.google.com/maps?q=${this.info.addresses.mainAddress.country.name},${this.info.addresses.mainAddress.state.name},${this.info.addresses.mainAddress.city.name}${this.info.addresses.mainAddress.postCode ? ',' + this.info.addresses.mainAddress.postCode : ''}${this.info.addresses.mainAddress.addressLines.addressLine1 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine1 : ''}${this.info.addresses.mainAddress.addressLines.addressLine2 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine2 : ''}${this.info.addresses.mainAddress.addressLines.addressLine3 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
            this.map2 = `https://maps.google.com/maps?q=${this.info.addresses.billingAddress.country.name},${this.info.addresses.billingAddress.state.name},${this.info.addresses.billingAddress.city.name}${this.info.addresses.billingAddress.postCode ? ',' + this.info.addresses.billingAddress.postCode : ''}${this.info.addresses.billingAddress.addressLines.addressLine1 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine1 : ''}${this.info.addresses.billingAddress.addressLines.addressLine2 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine2 : ''}${this.info.addresses.billingAddress.addressLines.addressLine3 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
            this.map3 = `https://maps.google.com/maps?q=${this.info.addresses.shippingWarehouseAddress.country.name},${this.info.addresses.shippingWarehouseAddress.state.name},${this.info.addresses.shippingWarehouseAddress.city.name}${this.info.addresses.shippingWarehouseAddress.postCode ? ',' + this.info.addresses.shippingWarehouseAddress.postCode : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

        // this.map1 = `https://maps.google.com/maps?q=${this.info.addresses.mainAddress.country.name},${this.info.addresses.mainAddress.state.name},${this.info.addresses.mainAddress.city.name}${this.info.addresses.mainAddress.postCode ? ',' + this.info.addresses.mainAddress.postCode : ''}${this.info.addresses.mainAddress.addressLines.addressLine1 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine1 : ''}${this.info.addresses.mainAddress.addressLines.addressLine2 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine2 : ''}${this.info.addresses.mainAddress.addressLines.addressLine3 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        // this.map2 = `https://maps.google.com/maps?q=${this.info.addresses.billingAddress.country.name},${this.info.addresses.billingAddress.state.name},${this.info.addresses.billingAddress.city.name}${this.info.addresses.billingAddress.postCode ? ',' + this.info.addresses.billingAddress.postCode : ''}${this.info.addresses.billingAddress.addressLines.addressLine1 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine1 : ''}${this.info.addresses.billingAddress.addressLines.addressLine2 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine2 : ''}${this.info.addresses.billingAddress.addressLines.addressLine3 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        // this.map3 = `https://maps.google.com/maps?q=${this.info.addresses.shippingWarehouseAddress.country.name},${this.info.addresses.shippingWarehouseAddress.state.name},${this.info.addresses.shippingWarehouseAddress.city.name}${this.info.addresses.shippingWarehouseAddress.postCode ? ',' + this.info.addresses.shippingWarehouseAddress.postCode : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
      } else {
        this.$router.push(`/clients?companyId=${this.$route.query.companyId}&companyClientId=${selectedRows[0].vendorId}&companyClientPersonId=${selectedRows[0].personId}`);
        this.businessUnitList = selectedRows[0].businessUnitList
        this.engagementList = selectedRows[0].engagementList
        this.projectList = selectedRows[0].projectList

        this.map = `https://maps.google.com/maps?q=${this.info.country ? this.info.country.name : ''},${this.info.state ? this.info.state.name : ''},${this.info.city ? this.info.city.name : ''}${this.info.postCode ? ',' + this.info.postCode : ''}${this.info.address ? ',' + this.info.address : ''}${this.info.address2 ? ',' + this.info.address2 : ''}${this.info.address3 ? ',' + this.info.address3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
      }

      // if (this.selectedRow.type === 'client') {
      //   this.$router.push(`/clients?companyId=${this.$route.query.companyId}&companyClientId=${selectedRows[0].vendorId}`);
      //   alert('lol')
      // } else {
      //   this.$router.push(`/clients?companyId=${this.$route.query.companyId}&companyClientId=${selectedRows[0].vendorId}&companyClientPersonId=${selectedRows[0].personId}`);
      // }

      switch (this.activeName) {
        case 'clientFiles':
          this.$store.dispatch('getClientsFiles')
          break;
        case 'clientPersonFiles':
          this.$store.dispatch('getClientsPersonsFiles')
          break;
      }
    },
    addPerson() {
      this.$refs['modal3'].$refs['addPerson'].open()
    },
    editPerson() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyClientPersons/item?companyId=${this.$route.query.companyId}&companyClientId=${this.$route.query.companyClientId}&companyClientPersonId=${this.$route.query.companyClientPersonId}`)
        .then(response => {
          console.log('---/companyVendorPersons/item', response.data);
          this.companyClientsPersonsItem = response.data.item
          this.$refs['modal4'].openModal()
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    handleClick(tab, event) {
      if(tab.name === 'clientFiles'){
        this.$store.dispatch('getClientsFiles')
      } else if (tab.name ==='clientPersonFiles') {
        this.$store.dispatch('getClientsPersonsFiles')
      } else if (tab.name === 'clientComment') {
        this.$refs['clientComment'].loadList()
      } else if (tab.name === 'clientMeetings') {
        this.$refs['clientMeetings'].loadList()
      } else if (tab.name === 'clientPersonsMeetings') {
        this.$refs['clientPersonsMeetings'].loadList()
      } else if (tab.name === 'at') {
        this.$refs['clientAT'].openTab()
      }
    },
    handleClickInfo(tab, event) {
      if(tab.name === 'accountTeam'){
        this.loadAccountTeamList()
      }
    }
  },
  watch: {
    rowData(val){
      if (val.length === 0) {
        this.disabledBtn = true
      }else{
        this.disabledBtn = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.clients {
  background: #DfE8F0;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__tree {
    width: 35%;
    padding: 0 10px 10px 0;
  }
  &__info {
    display: flex;
    flex-direction: column;
    width: 65%;
    padding: 0 0 0 10px;
  }
  &__info-tab {
    height: 100%;
    margin-top: 0px;
    overflow-y: auto;
    .isEmpty {
      color: #ccc
    }
    &_label {
      display: inline-block;
      width: 200px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #888;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
  }
}

.nav-tree {
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
  }
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}

/deep/.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{
  padding-left:0;
}

.button{
  cursor: pointer;
}

.el-tabs--border-card {
  height: 100%;
  overflow-x: hidden;
  /deep/.el-tabs__content {
    height: 100% !important;
  }
}

.importClients {
  width: 100%;
  &__label {
    width: 100%;
    color: #409EFF;
    padding: 7px 15px;;
    border: 1px solid #b3d8ff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background: #409EFF;
      border-color: #409EFF;
      color: #FFF;
    }
  }
}
</style>
